import * as end from '../constants/api'
import { axiosInstance } from './axios-instance'

const NPSService = {
	setNPS: ({ userId, payload }) => {
		return axiosInstance.post(end.setNPS({ userId }), payload).then(res => res.data)
	}
}

export default NPSService
